import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import menu_template from '~/templates/tra-menu.handlebars';
import GeneralView from '~/generalView';

var traMenulineView = GeneralView.View.extend({
    tagName: "div",
    className: '',
    events: {},

    render: function () {
      this.attachEvents();
      return this;
    },

    attachEvents: function() {
        var handlebarsTemplate = Handlebars.template(menu_template);
        this.$el.html(handlebarsTemplate());
        this.translate();    
    },
});
export default traMenulineView;